import 'slick-carousel/slick/slick';

export default function initSlickCarousel() {
	$( '.slick-gallery' ).slick( {
		slidesToShow: 1,
		dots: true,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 500,
	} );
}
